import api from "../api";
import axios from "axios";
import authService from "./AuthService";

const END_POINT = "/api/interventionsFollowed";

/**
 * This method will load all interventions Followed from the database with a get http call
 * @returns {} it is returning a promise with all interventions Followed
 */
export async function getAllInterventionsFollowedHttp() {
  return await api.get(`${END_POINT}`);
}

/**
 * This method will load interventions Followed depending of page and size parameters with a get http call
 *
 * @param  {} page page number that will be load
 * @param  {} size number of interventions Followed that will be load (represents LIMIT in sql)
 * @returns {} it is returning a promise with interventions Followed depending of page and size parameters
 */
export async function getAllInterventionsFollowedPaginationHttp(page, size) {
  return await api.get(`${END_POINT}/pagination`, {
    params: {
      page: page,
      size: size,
    },
  });
}

/**
 * This method will give the number of interventions Followed with a get http call
 *
 * @param  {String} type only interventions containing 'search' will be counted
 *
 * @returns {} it is returning a promise with the number of interventions Followed in the database
 */
export async function countInterventionsFollowedByUserTypeHttp(type) {
  return await api.get(`${END_POINT}/count/${type}`);
}

/**
 * This method is adding a intervention Followed from the database with a post http call
 *
 * @param  {Object - InterventionFollowedDto} interventionFollowed object that we want to add from the database
 * @returns {} it is returning a promise with the added intervention Followed
 */
export async function addInterventionFollowedHttp(interventionFollowed) {
  return await api.post(`${END_POINT}`, {
    userDto: interventionFollowed.userDto,
    advInterventionDto: interventionFollowed.advInterventionDto,
    registrationSlug: interventionFollowed.registrationSlug,
    version: interventionFollowed.version,
  });
}

/**
 * This method is updating a intervention Followed from the database with a put http call
 *
 * @param  {Object - InterventionFollowedDto} interventionFollowed object that we want to update from the database
 * @returns {} it is returning a promise with the updated interventionFollowed
 */
export async function updateInterventionFollowedHttp(interventionFollowed) {
  return await api
    .put(`${END_POINT}`, {
      id: interventionFollowed.id,
      userDto: interventionFollowed.userDto,
      advInterventionDto: interventionFollowed.advInterventionDto,
      registrationSlug: interventionFollowed.registrationSlug,
      version: interventionFollowed.version,
    })
    .catch(function (error) {
      return error.response.status;
    });
}

/**
 * This method is removing a intervention Followed from the database with a delete http call
 *
 * @param  {} id id of the intervention Followed we want to remove from the database
 * @returns {} it is returning a promise. You will have 202 status if the intervention Followed was deleted successfully.
 */
export async function deleteInterventionFollowedHttp(id) {
  return await api.delete(`${END_POINT}/${id}`);
}

/**
 * This method will load interventions Followed depending of the id of intervention selected - with a get http call
 *
 * @param  {} id id of the intervention that we want to get interventions Followed linked to it
 * @returns {} it is returning a promise with interventions Followed depending of the intervention's id
 */
export async function getAllInterventionsFollowedByInterventionIdHttp(id) {
  return await api.get(`${END_POINT}/interventionId/${id}`);
}

/**
 * This method will load interventions Followed depending of the user type selected - with a get http call
 *
 * @param  {} type user type to select (enum from the backend for trainer, salesperson, admin, etc)
 * @returns {} it is returning a promise with interventions Followed depending of the user type selected
 */
export async function getAllInterventionsFollowedByUserTypeHttp(type) {
  return await api.get(`${END_POINT}/userType/${type}`);
}

/**
 * This method will load interventions Followed depending of the user type selected and a date range - with a get http call
 *
 * @param  {} type        user type to select (enum from the backend for trainer, salesperson, admin, etc)
 * @param  {String} start date of the beginning
 * @param  {String} end   date of the ending
 *
 * @returns {} it is returning a promise with users depending of the user type selected
 */
export async function getAllInterventionsFollowedByUserTypeAndDateRangeHttp(
  type,
  start,
  end
) {
  return await api.get(
    `${END_POINT}/userTypeAndDateRange/${type}/${start}/${end}`
  );
}

/**
 * This method will load interventions Followed depending of the date range selected - with a get http call
 *
 * @param  {String} start date of the beginning
 * @param  {String} end   date of the ending
 *
 * @returns {} it is returning a promise with users depending of the date range selected
 */
export async function getAllInterventionsFollowedByDateRangeHttp(start, end) {
  return await api.get(`${END_POINT}/dateRange/${start}/${end}`);
}

/**
 * This method will fetch interventions Followed from the webservice Wdg2 with a get http call
 *
 *  @param  {Object - LogInUser} logInUser user dg2
 *
 */
export async function fetchAllInterventionsFollowedDG2Http(logInUser, year) {
  return await axios.get(
    `${process.env.VUE_APP_BASE_URL}${END_POINT}/dg2/${year.dateStart}/${year.dateEnd}`,
    {
      headers: {
        Authorization: authService.getBearerToken(),
        "X-AUTH-TOKEN": `${logInUser.email}:${logInUser.password}`,
      },
      timeout: 500000,
    }
  );
}
